import React from "react";
import { useParams } from "react-router-dom";
import { Dropdown } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart, faShareAlt, faCopy } from "@fortawesome/free-solid-svg-icons";
import { faTwitterSquare, faFacebookSquare, faLinkedin } from "@fortawesome/free-brands-svg-icons";

import destinations from "../data/destination.json";

const TravelInfo = ({slug}) => {
  //const { slug } = useParams(); // URL se slug
  const destination = destinations.find((d) => d.slug === slug);
  if (!destination) {
    return <h2 className="text-center my-5">Destination not found</h2>;
  }

  return (
    <section className="py-0">
      <div className="container position-relative">
        {/* Title and button START */}
        <div className="row mb-3">
          <div className="col-12 mb-3">
            <div className="d-lg-flex justify-content-lg-between mb-1">
              <div className="mb-2 mb-lg-0">
                <h1 className="fs-3">{destination.title}</h1>
              </div>
             
            </div>
          </div>

          {/* Tabs */}
          <div className="col-12">
            <ul className="nav nav-pills nav-pills-dark mb-3">
              <li className="nav-item me-2">
                <a className="nav-link active" data-bs-toggle="tab" href="#About">About</a>
              </li>
              <li className="nav-item me-2">
                <a className="nav-link" data-bs-toggle="tab" href="#TouristAttractions">Popular Attractions</a>
              </li>
              <li className="nav-item me-2">
                <a className="nav-link" data-bs-toggle="tab" href="#RouteInformation">Route Information</a>
              </li>
              <li className="nav-item me-2">
                <a className="nav-link" data-bs-toggle="tab" href="#Services">Cab Services</a>
              </li>
            </ul>

            <div className="tab-content">
              {/* About */}
              <div className="tab-pane show active" id="About">
                <div className="row">
                  <div className="col-md-7 mb-2">
                    <p>{destination.about}</p>
                    <ul>
                      {destination.whyChooseUs.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  </div>
                  <div className="col-md-5 mb-2">
                   {destination.image!="" ? <img src={process.env.REACT_APP_API_IMAGE_URL+destination.image} alt={destination.title} className="img-fluid rounded" />
                 :null} </div>
                </div>
              </div>

              {/* Attractions */}
              <div className="tab-pane" id="TouristAttractions">
                <ul>
                  {destination.attractions.map((place, index) => (
                    <li key={index}>{place}</li>
                  ))}
                </ul>
              </div>

              {/* Route */}
              <div className="tab-pane" id="RouteInformation">
                <p><strong>Distance:</strong> {destination.route.distance}</p>
                <p><strong>Duration:</strong> {destination.route.duration}</p>
              </div>

              {/* Services */}
              <div className="tab-pane" id="Services">
                <ul>
                  {destination.services.map((service, index) => (
                    <li key={index}>{service}</li>
                  ))}
                </ul>
                <h5>{destination.cabService.title}</h5>
                <p>{destination.cabService.description}</p>
                <ul>
                  {destination.cabService.highlights.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
             
            </div>
          </div>
        </div>
        {/* Title and button END */}
      </div>
    </section>
  );
};

export default TravelInfo;
